import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { afterGetObjectCallbackInterface, onErrorCallbackInterface } from '../interfaces/interfaces';
import { GenericBaseService } from './generic-base.service';
import { UrlService } from "./url.service";

@Injectable({
  providedIn: 'root'
})

export class SettingsService extends GenericBaseService {

  constructor(
    protected httpClient: HttpClient,
    protected toastrService: ToastrService,
    protected url: UrlService
  ) {
    super('Settings', httpClient, toastrService, url);
  }

  getSettings<T>(url: string, afterGetObjectCallback: afterGetObjectCallbackInterface<T>) {
    this.getObject<T>(url, null, afterGetObjectCallback);
  }

  saveSettings<T>(url: string, settings: T, afterPostCallback?: Function, customMessage?: string) {
    return this.postNow(url, this.getBody(settings), afterPostCallback, customMessage);
  }

  testSettings<T>(url: string, settings: T, afterPostCallback?: Function, customMessage?: string) {
    return this.postNow(url, this.getBody(settings), afterPostCallback, customMessage);
  }

  /**
   * Tests settings without reporting the failure as a toast, handing the response to the caller
   * instead. For a check that returns a list of findings, which belongs on the page next to the
   * fields it is about rather than in something that disappears.
   */
  testSettingsQuietly<T>(url: string, settings: T, afterPostCallback: Function, customMessage: string,
                         onErrorCallback: onErrorCallbackInterface) {
    return this.postNow(url, this.getBody(settings), afterPostCallback, customMessage, true, true, false, onErrorCallback);
  }
}
